import { IBaseIconProps } from "./IBaseIconProps";

export const StatisticsIcon = ({ color = "#000" }: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
    >
      <g>
        <path
          d="m92.188 93.75h-84.375c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-9.375c0-0.86328 0.69922-1.5625 1.5625-1.5625h84.375c0.86328 0 1.5625 0.69922 1.5625 1.5625v9.375c0 0.86328-0.69922 1.5625-1.5625 1.5625zm-82.812-3.125h81.25v-6.25h-81.25z"
          fill={color}
        />
        <path
          d="m24.945 77.105c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-13.883h-9.3203v13.883c0 0.86328-0.69922 1.5625-1.5625 1.5625s-1.5625-0.69922-1.5625-1.5625v-15.445c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.445c0.86328 0 1.5625 0.69922 1.5625 1.5625v15.445c0 0.86328-0.69922 1.5625-1.5625 1.5625z"
          fill={color}
        />
        <path
          d="m45.797 77.105c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-30.93h-9.3203v30.93c0 0.86328-0.69922 1.5625-1.5625 1.5625-0.86328 0-1.5625-0.69922-1.5625-1.5625v-32.492c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.445c0.86328 0 1.5625 0.69922 1.5625 1.5625v32.492c0 0.86328-0.69922 1.5625-1.5625 1.5625z"
          fill={color}
        />
        <path
          d="m66.648 77.105c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-20.23h-9.3203v20.23c0 0.86328-0.69922 1.5625-1.5625 1.5625s-1.5625-0.69922-1.5625-1.5625v-21.793c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.445c0.86328 0 1.5625 0.69922 1.5625 1.5625v21.793c0 0.86328-0.69922 1.5625-1.5625 1.5625z"
          fill={color}
        />
        <path
          d="m87.5 77.105c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-39.605h-9.3203v39.605c0 0.86328-0.69922 1.5625-1.5625 1.5625-0.86328 0-1.5625-0.69922-1.5625-1.5625v-41.168c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.445c0.86328 0 1.5625 0.69922 1.5625 1.5625v41.168c0 0.86328-0.69922 1.5625-1.5625 1.5625z"
          fill={color}
        />
        <path
          d="m62.797 33.75c-0.36719 0-0.73828-0.12891-1.0352-0.39062-0.64844-0.57031-0.70703-1.5586-0.13672-2.2031l15.812-17.875c0.57422-0.64844 1.5625-0.70312 2.2031-0.13672 0.64844 0.57031 0.70703 1.5586 0.13672 2.2031l-15.812 17.875c-0.30859 0.35156-0.73828 0.52734-1.1719 0.52734z"
          fill={color}
        />
        <path
          d="m57.297 34.422c-0.30078 0-0.60547-0.085937-0.875-0.26953l-14.578-9.875c-0.71484-0.48438-0.90234-1.457-0.41797-2.1719 0.48438-0.71484 1.4609-0.89844 2.1719-0.41797l14.578 9.875c0.71484 0.48438 0.90234 1.457 0.41797 2.1719-0.30078 0.44531-0.79688 0.6875-1.2969 0.6875z"
          fill={color}
        />
        <path
          d="m21.469 41.891c-0.38281 0-0.76562-0.14062-1.0703-0.42188-0.62891-0.58984-0.66406-1.5781-0.074219-2.2109l15.641-16.719c0.59375-0.63281 1.5781-0.66406 2.2109-0.074218 0.62891 0.58984 0.66406 1.5781 0.074219 2.2109l-15.641 16.719c-0.30859 0.32812-0.72656 0.49219-1.1406 0.49219z"
          fill={color}
        />
        <path
          d="m18.938 48.32c-2.9141 0-5.2812-2.3711-5.2812-5.2812 0-2.9141 2.3711-5.2812 5.2812-5.2812 2.9141 0 5.2812 2.3711 5.2812 5.2812 0 2.9141-2.3711 5.2812-5.2812 5.2812zm0-7.4414c-1.1914 0-2.1562 0.96875-2.1562 2.1562 0 1.1914 0.96875 2.1562 2.1562 2.1562 1.1914 0 2.1562-0.96875 2.1562-2.1562 0-1.1914-0.96875-2.1562-2.1562-2.1562z"
          fill={color}
        />
        <path
          d="m39.645 26.191c-2.9141 0-5.2812-2.3711-5.2812-5.2812 0-2.9141 2.3711-5.2812 5.2812-5.2812 2.9141 0 5.2812 2.3711 5.2812 5.2812 0 2.9141-2.3711 5.2812-5.2812 5.2812zm0-7.4414c-1.1914 0-2.1562 0.96875-2.1562 2.1562 0 1.1914 0.96875 2.1562 2.1562 2.1562 1.1914 0 2.1562-0.96875 2.1562-2.1562 0-1.1914-0.96875-2.1562-2.1562-2.1562z"
          fill={color}
        />
        <path
          d="m60.355 40.254c-2.9141 0-5.2812-2.3711-5.2812-5.2812 0-2.9141 2.3711-5.2812 5.2812-5.2812 2.9141 0 5.2812 2.3711 5.2812 5.2812 0 2.9141-2.3711 5.2812-5.2812 5.2812zm0-7.4414c-1.1914 0-2.1562 0.96875-2.1562 2.1562 0 1.1914 0.96875 2.1562 2.1562 2.1562 1.1914 0 2.1562-0.96875 2.1562-2.1562 0-1.1914-0.96875-2.1562-2.1562-2.1562z"
          fill={color}
        />
        <path
          d="m81.062 16.816c-2.9141 0-5.2812-2.3711-5.2812-5.2812 0-2.9141 2.3711-5.2812 5.2812-5.2812 2.9141 0 5.2812 2.3711 5.2812 5.2812 0 2.9141-2.3711 5.2812-5.2812 5.2812zm0-7.4414c-1.1914 0-2.1562 0.96875-2.1562 2.1562 0 1.1914 0.96875 2.1562 2.1562 2.1562 1.1914 0 2.1562-0.96875 2.1562-2.1562 0-1.1914-0.96875-2.1562-2.1562-2.1562z"
          fill={color}
        />
      </g>
    </svg>
  );
};
